var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarBoxBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.364 32.9167C72.2422 28.6013 71.834 25.8495 70.4515 23.5025C68.4831 20.1615 64.9413 18.3017 57.8609 14.5887L51.2776 11.1324C45.4974 8.10079 42.6073 6.58333 39.5 6.58333C36.3927 6.58333 33.5026 8.0975 27.7224 11.1324L21.1391 14.5887C14.0587 18.3017 10.5169 20.1615 8.54845 23.5025C6.58333 26.8402 6.58333 30.9976 6.58333 39.3091V39.6942C6.58333 48.0024 6.58333 52.1598 8.54845 55.4975C10.5169 58.8385 14.0587 60.6983 21.1391 64.4146L27.7224 67.8676C33.5026 70.8992 36.3927 72.4167 39.5 72.4167C42.6073 72.4167 45.4974 70.9025 51.2776 67.8676L57.8609 64.4113C64.9413 60.695 68.4831 58.8385 70.4515 55.4975C71.834 53.1505 72.2422 50.3987 72.364 46.0833M69.125 24.6875L55.9583 31.2708M55.9583 31.2708L54.3125 32.0937L39.5 39.5M55.9583 31.2708V42.7917M55.9583 31.2708L24.6875 14.8125M39.5 39.5L9.87499 24.6875M39.5 39.5V70.7708",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarBoxBroken);
export default __webpack_public_path__ + "static/media/solar_box-broken.1e0111bd3472e858c83f057b077e04d9.svg";
export { ForwardRef as ReactComponent };